import editContact from "../../containers/editContact";
import EditContactPhoneNumber from "./EditContactPhoneNumber";

export default editContact(EditContactPhoneNumber);
